export const contentActions = {
  CREATED: 'created',
  VERIFIED_TAG_ADDED: 'verified_tag_added',
  VERIFIED_TAG_REMOVED: 'verified_tag_removed',
  SUGGESTED: 'suggested',
  AUTOMATICALLY_SUGGESTED: 'automatically_suggested',
  SAVED: 'saved',
  UNSAVED: 'unsaved',
  SCHEDULED: 'scheduled',
  // legacy action replaced by AUTOMATICALLY_SUGGESTED
  RECOMMENDED: 'recommended',
};

export const contentDismissReasons = {
  NOT_RELEVANT: 'not_relevant',
  BEHIND_PAYWALL: 'behind_paywall',
  NOT_EMPLOYER_BRANDING: 'not_employer_branding',
  PROMOTIONAL_CONTENT: 'promotional_content',
  MUTE_DOMAIN: 'mute_domain',
};
